// W2CP v1 (see README): catalog version plus one byte per point, the cheapest ad-hoc kWh price in whole
// cents, rounded up (0 = not reported). Only loaded once the price filter is used.
const hex = b => [...b].map(v => v.toString(16).padStart(2, '0')).join('');
export function decodePrices(buffer) {
  const b = new Uint8Array(buffer), v = new DataView(buffer);
  if (b.length < 17 || String.fromCharCode(...b.slice(0, 4)) !== 'W2CP' || b[4] !== 1) throw Error('invalid prices');
  const count = v.getUint32(13, true);
  if (b.length !== 17 + count) throw Error('incomplete prices');
  return {version: hex(b.slice(5, 13)), cents: b.subarray(17)};
}
// Writes p.ct onto every charge point; refuses a table from another catalog version.
export function attachPrices(sites, table) {
  const flat = sites.flatMap(s => s.points || []);
  if (table.version !== sites.version || table.cents.length !== flat.length) throw Error('catalog change');
  for (const p of flat) p.ct = table.cents[p.index];
  for (const site of sites) site.secondaryVersion = (site.secondaryVersion || 0) + 1;
  sites.prices = table.version;
  return sites;
}
export async function loadPrices(sites, fetcher = globalThis.fetch, decoder = decodePrices) {
  if (sites.prices === sites.version) return sites;
  const response = await fetcher('/api/prices.bin', {cache: 'no-cache'});
  if (!response.ok) throw Error('prices');
  return attachPrices(sites, await decoder(await response.arrayBuffer()));
}
